import { AxiosError } from 'axios';
import { StatusCodes } from 'global/status-codes';
import { ErrorType } from './types';

export function mapHttpError(error: AxiosError): ErrorType {
  const genericErrorMessage = 'Something Failed. Try again?';

  if (error.response) {
    if (error.response.data) {
      return {
        authToken: error.response.config.headers.Authorization as any,
        statusCode: error.response.status,
        message:
          (error.response.data as any).message
          || (error.response.data as any).error
          || genericErrorMessage,
      };
    }
  }

  return {
    authToken: error.response?.config.headers.Authorization as any,
    statusCode: StatusCodes.INTERNAL_SERVER_ERROR,
    message: genericErrorMessage,
  };
}
